/**
 * @file     useSettled.ts
 * @purpose  Returns a value once it has stopped changing for `delayMs`, so a
 *           live tool reports its inputs (profile writes, CRM milestones,
 *           analytics) when the visitor pauses, not on every slider tick.
 *           Pass a primitive (a number or a serialized key): an object made
 *           fresh each render never settles.
 */
'use client';

import { useEffect, useState } from 'react';

export function useSettled<T extends string | number>(value: T, delayMs = 1500): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = window.setTimeout(() => setSettled(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [delayMs, value]);
  return settled;
}
